import React, { useState } from 'react'
import cx from 'classnames'
import style from './faqItem.module.scss'
import { VegaHeading } from '../../vega/heading/Heading'
import { VegaIcon } from '../../vega/icon/Icon'
import { PropTypes } from 'prop-types'

/**
 * Dropdown component that extends at click
 */
const FAQItem = ({ className, question, answer }) => {
	const [isExpanded, setExpanded] = useState(false)

	return (
		<div className={cx(className, style.faqItem)}>
			<div className={style.question} onClick={() => setExpanded(!isExpanded)}>
				<VegaHeading className={style.heading} label={question} tag="h4" />
				<VegaIcon
					className={style.icon}
					name={isExpanded ? 'reduce' : 'open'}
					size={22}
				/>
			</div>
			<div className={cx(style.answer, { [style.active]: isExpanded })}>
				<p>{answer}</p>
			</div>
		</div>
	)
}

FAQItem.propTypes = {
	/** Allow to set a classname on the component */
	className: PropTypes.string,
	/** Title of the section */
	question: PropTypes.string,
	/** Content of the section */
	answer: PropTypes.string
}

export { FAQItem }
